import { Component, OnInit } from '@angular/core';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';
import { AuthService } from './../../auth/auth.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { Router } from '@angular/router';
import { UtilsService } from '../../services/utils.service';
import Swal from 'sweetalert2';
import { environment } from 'src/environments/environment';
import {CognitoService} from "../../services/cognito.service";
import { DocumentsService } from 'src/app/services/document.service';
import { v4 as uuidv4 } from 'uuid';
declare var $: any;

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

    private loggedIn: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    formLogin: FormGroup;
    formRegistro: FormGroup;

    rol: any = "";
    userData:any="";

    isLoggedIn$: any;

    isLoading: boolean = false;
    submitLogin: boolean = false;
    submitRegister: boolean = false;
    showLogin: boolean = true;

    diaNacimiento = this.utilService.days();
    mesNacimiento = this.utilService.months();
    anoNacimiento = this.utilService.years();


    constructor(private fb  : FormBuilder,
                private auth: AuthService,
                private router: Router,
                private utilService: UtilsService,
                private documentService: DocumentsService,
                private cognitoService: CognitoService)
    {
        this.formLogin = this.fb.group
        ({
            // email: ['', [Validators.required]],
            email: ['', [Validators.required, Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$')]],
            password: ['', [Validators.required, Validators.pattern(/^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@$!%*?&#.])[A-Za-z\d@$!%*?&#.]{8,}$/)]]
        });
        this.formRegistro = this.fb.group
        ({
            name: ['', [Validators.required]],
            birthDate: [''],
            fechaNacimientoSeparada: this.fb.group({
              dia: [null, [Validators.required]],
              mes: [null, [Validators.required]],
              anio: [null, [Validators.required]]
            }),
            email: ['', [Validators.required, Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$')]],
            password: ['', [Validators.required,  Validators.minLength(6), this.passwordValidator]],
            confirmPassword: ['', [Validators.required]],
            lada: [{value:'+52', disabled: false}, [Validators.required, Validators.pattern("^[0-9+]*$")]],
            phoneNumber: [{value:'', disabled:false}, [Validators.required, Validators.pattern("^[0-9]*$"), Validators.minLength(10)]],
            fitnessName: ['', [Validators.required]],
            acceptTerms: [false, [Validators.required]],
        })
    }

    ngOnInit() {
        // this.cognitoService.getCurrentUser().then((res) => {
        //     console.log(res)
        //     switch(res.attributes['custom:userRole']) {
        //         case 'cliente': {
        //             window.location.href = '/cliente';
        //             break;
        //         }
        //         case 'admin': {
        //             window.location.href = '/trainer';
        //             break;
        //         }
        //         case 'entrenador': {
        //             window.location.href = '/trainer';
        //             break;
        //         }
        //         default: {
        //             window.location.href = '/login';
        //             break;
        //         }
        //     }
        // }).catch((err) => {
        //     console.log(err)
        //     // Swal.fire('Error', 'Ocurrió un error al registrar el usuario.', 'error');
        // })
    }

    changeShowLoginVal(val)
    {
        this.submitLogin = false;
        this.submitRegister = false;
        this.showLogin = val;
    }
    abrirCalendario(input: HTMLInputElement): void {
        input.showPicker(); // Activa el selector de fecha
    }
    // Validador personalizado para la contraseña
    passwordValidator(control: any): { [key: string]: boolean } | null {
        const password = control.value || '';
        const hasNumber = /\d/.test(password); // Verifica si contiene un número
        const hasUpperCase = /[A-Z]/.test(password); // Verifica si contiene una letra mayúscula
        const hasLowerCase = /[a-z]/.test(password); // Verifica si contiene una letra minúscula

        if (!hasNumber || !hasUpperCase || !hasLowerCase) {
        return { invalidPassword: true };
        }
        return null;
    }

    onSignIn(){
        this.submitLogin = true;
        if(this.formLogin.status == "INVALID")
        {
            console.log(this.formLogin)
            return;
        }
        this.cognitoService.signIn(this.formLogin.value.email, this.formLogin.value.password).then((res) => {
            
            console.log(res)
            localStorage.setItem('email', this.formLogin.value.email);

            console.log(res.attributes["custom:userRole"]);

            switch(res.attributes["custom:userRole"]){
                
                case 'admin':{
                    this.rol = 'admin';
                    this.documentService.getDocumentContainer(
                        environment.businessId,
                        this.formLogin.value.email,
                    ).subscribe({
                        next: data => {
                            console.log(data);
        
                            // CREATE LOCALSTORAGE ITEM WITH USER DATA
                            localStorage.setItem('userData', JSON.stringify(data));
        
                        },
                        error: error => {
                            console.error('There was an error!', error);
                        },
                        complete: () => {
                            window.location.href = '/trainer';
                        }
                    })
                    break;
                }

                case 'cliente':{
                    Swal.fire('Advertencia', 'No cuenta con un rol permitido para iniciar sesión.', 'warning');
                    this.auth.logout();

                    // this.rol = 'cliente';
                    //
                    // console.log(res.attributes["custom:masterContainerId"])
                    //
                    // this.documentService.getDocumentsByType(
                    //    environment.businessId,
                    //    res.attributes["custom:masterContainerId"],
                    //   'cliente'
                    // ).subscribe({
                    //   next: (response: any) => {
                    //
                    //     const selectedUser = response.content.find(user => user.email === this.formLogin.value.email);
                    //
                    //     console.log(selectedUser);
                    //     this.userData = selectedUser;
                    //     localStorage.setItem('userData', JSON.stringify(selectedUser));
                    //   },
                    //   error: (error) => {
                    //     console.log(error);
                    //   },
                    //   complete: () => {
                    //       window.location.href = '/cliente';
                    //   }
                    // })
                    break;
                }

                case 'entrenador':{
                    this.rol = 'entrenador';

                    console.log(res.attributes["custom:masterContainerId"])

                    this.documentService.getDocumentsByType(
                       environment.businessId,
                       res.attributes["custom:masterContainerId"],
                      'entrenador'
                    ).subscribe({
                      next: (response: any) => {

                        const selectedUser = response.content.find(user => user.email === this.formLogin.value.email);

                        console.log(selectedUser);
                        this.userData = selectedUser;
                      },
                      error: (error) => {
                        console.log(error);
                      },
                      complete: () => {
                        $("#modal-rolDiferente").modal({ backdrop: "static", keyboard: false });
                        $("#modal-rolDiferente").modal("show");
                      }
                    })
                    break;
                }

            }

            
        }).catch((err) => {
            console.log(err)

            if (err.code == "UserNotConfirmedException") {
        
                this.cognitoService.resendConfirmationCode(this.formLogin.value.email).then((res) => {
                  console.log(res);
                })
        
                Swal.fire({
                  title: 'Verifica tu cuenta',
                  text: 'Ingresa el código de confirmación que te enviamos a tu correo',
                  input: 'text',
                  inputAttributes: {
                    autocapitalize: 'off'
                  },
                  showCancelButton: false,
                  confirmButtonText: 'Confirmar',
                  showLoaderOnConfirm: true,
                  preConfirm: (code) => {
                    return this.cognitoService.confirmSignUp(this.formLogin.value.email, code).then((res) => {
                      return res;
                    }).catch((err) => {
                        console.log(err);
                    });
                  },
                  allowOutsideClick: () => !Swal.isLoading()
                }).then((result) => {
                  if (result.isConfirmed) {
                    Swal.fire('Confirmed!', 'Ya estas registrado!', 'success');
                    this.router.navigate(['dashboard/points']);
                  }
                })
            };
        })
    }

    loginTrainer(){
        // this.utilService.generateCryptoRol("Manager", 1);
        Swal.close();
        this.submitLogin = false;
        window.location.href = 'trainer';
        //this.router.navigate(['home']);
    }

    onRegister()
    {
        console.log(this.formRegistro.value)
        this.submitRegister = true;
        if(this.formRegistro.invalid)
        {
            Swal.fire('Advertencia', 'Verifica que los campos sean válidos.', 'warning');
            return;
        }
        if(this.formRegistro.get('password').value != this.formRegistro.get('confirmPassword').value)
        {
            Swal.fire('Advertencia', 'Verifica que las contraseñas sean iguales.', 'warning');
            return;
        }
        if(!this.formRegistro.get('acceptTerms').value)
        {
            Swal.fire('Advertencia', 'Acepta los Términos y Condiciones.', 'warning');
            return;
        }

        this.cognitoService.signUp(
            this.formRegistro.value.email,
            this.formRegistro.value.email,
            this.formRegistro.value.password,
            this.formRegistro.value.lada + this.formRegistro.value.phoneNumber,
            'admin',
            ''
        ).then((res) => {
            Swal.fire({
                title: "Ingresa el código de verificación",
                input: "text",
                inputLabel: "El Código fue enviado al correo registrado",
                showCancelButton: true,
                inputValidator: (value) => {
                  if (!value) {
                    return "Necesitas escribir el código!";
                  } else{
                    this.cognitoService.confirmSignUp(this.formRegistro.value.email, value).then((res) => {
                        console.log(res)
                        Swal.fire('Éxito', 'Favor de iniciar sesión', 'success');
                        this.showLogin = true;

                        let businessId = environment.businessId;

                        // CREATE USER DOCUMENT CONTAINER
                        this.documentService.createDocumentContainer(
                            businessId,
                            this.formRegistro.value.email,
                            'usuarios',
                            null,
                            {
                                admin: true,
                                nombre: this.formRegistro.value.name,
                                email: this.formRegistro.value.email,
                                fechaNacimiento: this.formRegistro.value.birthDate,
                                telefono: this.formRegistro.value.lada + this.formRegistro.value.phoneNumber,
                                empresaId: uuidv4(),
                                nombreEmpresa: this.formRegistro.value.fitnessName,
                            }
                        ).subscribe({
                            next: data => {
                                console.log(data);
                                // darlo de alta como entrenador
                                let trainerModel = {
                                    nombre: this.formRegistro.value.name,
                                    sexo: '',
                                    fechaNacimiento: this.formRegistro.value.birthDate,
                                    email: this.formRegistro.value.email,
                                    password: '',
                                    telefono: this.formRegistro.value.lada + this.formRegistro.value.phoneNumber,
                                    rol: 'admin-entrenador',
                                    contenedorPadre: data.documentContainerId,
                                    activo: true,
                                }
                                this.documentService.createDocumentInContainer(
                                    environment.businessId,
                                    data.documentContainerId, //UUID
                                    trainerModel.email,
                                    'entrenador',
                                    null,
                                    trainerModel
                                ).subscribe({
                                    next: (response: any) => {
                                        // this.entrenadores.push(response);

                                    },
                                    error: (error) => {
                                        console.log(error);
                                        // REMOVE IF COGNITO FAILS
                                    },
                                    complete: () => {
                                        Swal.fire({
                                            title: "Administrador creado",
                                            text: "El Usuario Administrador ha sido creado correctamente. Ahora puede iniciar sesión.",
                                            icon: "success",
                                        })
                                    }
                                })
                            },
                            error: error => {
                                console.error('There was an error!', error);
                            },
                            complete: () => {

                            }
                        })

                    }).catch((err) => {
                        console.log(err)
                        Swal.fire('Error', 'Ocurrió un error al verificar el código.', 'error');
                    });
                  }
                }
            });
        }).catch((err) => {
            let error = err.toString()
            if(error.includes('User already exists')){
                Swal.fire('Error', 'Ya existe un usuario con este correo. Intente recuperar su contraseña o registre un correo nuevo.', 'error');
            }else{
                Swal.fire('Error', 'Ocurrió un error al registrar el usuario.', 'error');
            }

        })

    }

    get formLoginControl()
    {
        return this.formLogin.controls;
    }
    get formRegisterControl()
    {
        return this.formRegistro.controls;
    }

    cerrarSesion()
    {
        console.log(localStorage.getItem('userData'));
        this.auth.logout();
    }

    printFecha(){
        if (this.formRegistro.get('fechaNacimientoSeparada.anio')?.value && this.formRegistro.get('fechaNacimientoSeparada.mes')?.value && this.formRegistro.get('fechaNacimientoSeparada.dia')?.value) {
          const fecha = `${this.formRegistro.get('fechaNacimientoSeparada.anio')?.value}-${this.formRegistro.get('fechaNacimientoSeparada.mes')?.value}-${this.formRegistro.get('fechaNacimientoSeparada.dia')?.value.padStart(2, '0')}`;
            this.formRegistro.get('birthDate')?.setValue(fecha); 
            console.log(fecha);
        }
      }

}
